import React from "react";

export default function ConfirmCheckbox(props) {
  const {
    name,
    checked,
    onChange,
    touched,
    errors,
    text,
    checkBoxAlignItems,
    isBold,
  } = props || {};
  return (
    <>
      <div
        className={`flex gap-2 sm:flex-row sm:gap-4 md:gap-4 mt-8 ${
          isBold ? "font-bold" : ""
        }`}
      >
        <label
          className="flex"
          style={{
            alignItems: checkBoxAlignItems ? checkBoxAlignItems : "center",
          }}
        >
          <input
            name={name}
            type="checkbox"
            value={"confirm"}
            checked={checked}
            onChange={onChange}
            style={{ minWidth: "24px" }}
          />
          {text}
        </label>
      </div>
      {touched[name] && errors[name] ? (
        <div className="error">{errors[name]}</div>
      ) : null}
    </>
  );
}
